import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Itemcoursskltn = (props) => {

    const [arry, setArry] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 14, 15, 16, 17, 18, 19, 20])

    return (
        <>
            {arry.slice(0, 3).map((info, index) =>
                <div className="item-course skltn">
                    <div className="title-detail">
                        <span>
                            <Skeleton variant="rect" width={150} height={26} />
                        </span>
                        <Skeleton variant="text" width={100 + '%'} height={26} />
                        <Skeleton variant="text" width={100 + '%'} height={26} />
                    </div>
                    <div className="row-details">
                        <span>
                            <b>
                                <Skeleton variant="rect" width={80} height={28} />
                            </b>
                            <Skeleton variant="rect" width={100} height={28} />
                            <Skeleton variant="rect" width={32} height={28} />
                        </span>
                        <div className="btns">
                            <div className={`btn-base btn-black btn-sircle`}>
                                <Skeleton variant="rect" width={150} height={38} />
                            </div>
                            <div className={`btn-base btn-black btn-sircle`}>
                                <Skeleton variant="rect" width={150} height={38} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Itemcoursskltn;